import React, { useState, useEffect } from 'react';
import LcLoading from '../../../components/Generic/LcLoading';
import SideModal from '../../../components/Layout/SideModal/SideModal';
import { RootState } from '../../../store/index';
import { MenuState } from '../../../store/reducers/menuReducer';
import { UserState } from '../../../store/reducers/userReducer';
import { useSelector } from 'react-redux';
import LcDropDown from '../../../components/Generic/LcDropDown';
import { CircularProgress } from '@material-ui/core';
import "./index.css";
import BusinessAreaService from '../../../services/BusinessAreaService/BusinessAreaService';
import CustomerService from '../../../services/CustomerService/CustomerService';
import ServiceGroupService from '../../../services/ServiceGroupService/ServiceGroupService';
import SolicitationService from '../../../services/SolicitationService/SolicitationService';
import ProcessService from '../../../services/ProcessService/ProcessService';
import ServiceService from '../../../services/ServiceService/ServiceService';
import FastSolicitationService from '../../../services/FastSolicitationService/FastSolicitationService';
import SolicitationAttachmentService from '../../../services/SolicitationAttachmentService/SolicitationAttachmentService';
import LcIconLink from '../../../components/Generic/LcIconLink';
import { useDebounce } from 'use-debounce';
import { ServiceGroupSearch } from "../../../models/ServiceGroupSearch";
import Parse from 'html-react-parser';
import { PPDropDown, PPGrid, PPTextField, PPUploader } from 'processor-plataform-ui';
import ClassificationGroupService from '../../../services/ClassificationGroupService/ClassificationGroupService';
import ClassificationService from '../../../services/ClassificationService/ClassificationService';
import HeyHoUserService from '../../../services/HeyHoUserService/HeyHoUserService';
import { SolicitationUrgencyPortugues } from '../../../models/solicitation';
import ModeOpeningService from '../../../services/ModeOpeningService/ModeOpeningService';
import moment from 'moment';
import { AlertColor } from '../../../components/Dialog/AlertNotification';
import LcAccordion from '../../../components/Generic/LcAccordion';
import { PPFormHH, PPFormTemplate } from '../../../components/Layout/PPFormHH/PPFormHH';
import { FastSolicitationAttendant } from "../../../models/FastSolicitation";
import { CommentType } from "../../../models/SolicitationComment";
import { SolicitationView } from "../../../models/SolicitationView";
import { Validation } from "../../../services/TextTools/TextTools";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Modal from '../../../components/Dialog/Modal';
import HHRichTextBoxDescriptionNew from '../../../components/Form/HHRichTextBoxDescriptionNew';
import LcIcon from '../../../components/Generic/LcIcon';
import TextTools from '../../../services/TextTools/TextTools';
import { escapeRegExp } from 'lodash';
import HHDescriptionTextBox from '../../../components/Form/HHDescriptionTextBox';
import SelectDropdown from '../../../components/Generic/SelectDropdown';

interface Props {
    show: boolean,
    handleClose: Function,
    duplicateRow: SolicitationView,
    templateSelected: any,
}

const AttendanceNewSolicitation: React.FC<Props> = (props) => {
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const user = useSelector<RootState, UserState>(state => state.user);

    const businessAreaService = new BusinessAreaService(props);
    const customerService = new CustomerService(props);
    const serviceGroupService = new ServiceGroupService(props);
    const processService = new ProcessService(props);
    const solicitationService = new SolicitationService(props);
    const serviceService = new ServiceService(props);
    const fastSolicitationService = new FastSolicitationService(props);
    const solicitationAttachmentService = new SolicitationAttachmentService(props);
    const classificationGroupService = new ClassificationGroupService(props);
    const classificationService = new ClassificationService(props);
    const heyHoUserService = new HeyHoUserService(props);
    const modeOpeningService = new ModeOpeningService(props);
    const textTools = new TextTools();

    const resultData = {};
    let refreshSeed: number | undefined;

    const [modalVisible, setModalVisible] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false);
    const [disable, setDisable] = useState<boolean>(false);
    const [loadingBusinessArea, setLoadingBusinessArea] = useState<boolean>(false);
    const [loadingCustomer, setLoadingCustomer] = useState<boolean>(false);
    const [loadingServiceGroup, setLoadingServiceGroup] = useState<boolean>(false);
    const [loadingService, setLoadingService] = useState<boolean>(false);
    const [loadingProcess, setLoadingProcess] = useState<boolean>(false);
    const [loadingClassificationGroup, setLoadingClassificationGroup] = useState<boolean>(false);
    const [loadingClassification, setLoadingClassification] = useState<boolean>(false);
    const [loadingRequester, setLoadingRequester] = useState<boolean>(false);
    const [loadingAttendant, setLoadingAttendant] = useState<boolean>(false);
    const [businessAreaList, setBusinessAreaList] = useState<any[]>([]);
    const [businessUnitList, setBusinessUnitList] = useState<any[]>([]);
    const [customerList, setCustomerList] = useState<any[]>([]);
    const [serviceGroupList, setServiceGroupList] = useState<any[]>([]);
    const [processList, setProcessList] = useState<any[]>([]);
    const [serviceList, setServiceList] = useState<any[]>([]);
    const [classificationGroupList, setClassificationGroupList] = useState<any[]>([]);
    const [classificationList, setClassificationList] = useState<any[]>([]);
    const [requesterList, setRequesterList] = useState<any[]>([]);
    const [requesterListFiltered, setRequesterListFiltered] = useState<any[]>([]);
    const [attendantList, setAttendantList] = useState<any[]>([]);
    const [serviceListAll, setServiceListAll] = useState<any[]>([]);
    const [urgencyList, setUrgencyList] = useState<any[]>([]);
    const [modeOpeningList, setModeOpeningList] = useState<any[]>([]);
    const [solicitationGroupList, setSolicitationGroupList] = useState<any[]>([]);
    const [searchResult, setSearchResult] = useState<ServiceGroupSearch[]>([]);
    const [searchResultLoading, setSearchResultLoading] = useState<boolean>(true);
    const [openNotificacao, setOpenNotificacao] = useState<boolean>(false);
    // const [openNotificacaoCreatedTicket, setOpenNotificacaoCreatedTicket] = useState<boolean>(false);
    const [severity, setSeverity] = useState<AlertColor>("info");
    const [message, setMessage] = useState<string>("");
    const [detailing = "", setDetailing] = useState<string>("");
    const [openAttachmentModal, setOpenAttachmentModal] = useState<boolean>(false);
    const [templatePPForm, setTemplatePPForm] = useState<PPFormTemplate>();
    const [resultDataResult, setResultDataResult] = useState<any>();
    const [error, setError] = useState<any>();
    const [saveTemplate, setSaveTemplate] = useState<boolean>(false);
    const [nameTemplate, setNameTemplate] = useState<string>("");
    const [disableButton, setDisableButton] = useState<boolean>(true);
    const [subject = "", setSubject] = useState<string>("");
    const [search = "", setSearch] = useState<string>();
    const [searchDebounce] = useDebounce(search, 300);
    const [solicitationNumber, setSolicitationNumber] = useState<number>(0);
    const [isloading, setIsLoading] = useState<boolean>(false);
    const [groupSelection, setGroupSelection] = useState<boolean>(false);
    const [files, setFiles] = useState<any[]>([]);
    const [loadSave, setLoadSave] = useState<boolean>(false);
    const [telefoneValue, setTelefoneValue] = useState<any>();

    const selectionDefaultAux = {
        userId: Number(user.id),
        idBusinessArea: 0,
        // idBusinessUnit: 0,
        idCustomer: 0,
        idServiceGroup: 0,
        idService: 0,
        idProcess: 0,
        idClassification: 0,
        idClassificationGroup: 0,
        idRequester: 0,
        idAttendant: 0,
        idUrgency: 1,
        idOpeningMode: 0,
        initialDate: moment(new Date()).format("YYYY-MM-DD"),
        initialTime: moment(new Date()).format("HH:mm"),
        idSolicitationGroup: 0
    }

    const [selectionDefault, setSelectionDefault] = useState({ ...selectionDefaultAux });

    let newSolicitation_: FastSolicitationAttendant = {
        id: 0,
        idService: 0,
        idProcess: 0,
        urgency: 1,
        suggestedDate: new Date(),
        subject: "",
        aditionalName: "",
        aditionalPhone: "",
        aditionalEmail: "",
        idUserRequester: 0,
        IdAttendant: 0,
        idCustomer: 0,
        detailing: "",
        nicknameUserRequester: "",
        autoPlay: false,
        startDate: new Date(),
        idBusinessArea: 0,
        idClassification: 0,
        idUserOpening: 0,
        modeOpening: 0,
        SolicitationFormResponseView: {},
        idSolicitationGroup: 0,
        saveTemplate: 0,
        nameTemplate: "",
        idGroupClassificationTemplate: 0,
        idUserAttendantTemplate: 0,
    };

    const [newSolicitation, setNewSolicitation] = useState<FastSolicitationAttendant>(newSolicitation_);

    const validationsDefault: Validation[] = [
        {
            name: 'subject',
            message: 'Preencha um assunto válido',
            valid: true,
        },
        {
            name: 'detailing',
            message: 'Preencha um detalhamento válido',
            valid: true,
        },
        {
            name: 'idBusinessArea',
            message: 'Selecione uma área de negócio válida',
            valid: true,
        },
        //{
        //    name: 'idBusinessUnit',
        //    message: 'Selecione uma unidade de negócio válida',
        //    valid: true,
        //},
        {
            name: 'idUrgency',
            message: 'Selecione uma urgência válida',
            valid: true,
        },
        {
            name: 'idCustomer',
            message: 'Selecione um cliente válido',
            valid: true,
        },
        {
            name: 'idServiceGroup',
            message: 'Selecione um grupo de serviço válido',
            valid: true,
        },
        {
            name: 'idService',
            message: 'Selecione um serviço válido',
            valid: true,
        },
        {
            name: 'idProcess',
            message: 'Selecione um processo válido',
            valid: true,
        },
        {
            name: 'idClassificationGroup',
            message: 'Selecione um grupo de classificação válido',
            valid: true,
        },
        {
            name: 'idClassification',
            message: 'Selecione uma classificação válida',
            valid: true,
        },
        {
            name: 'idRequester',
            message: 'Selecione um solicitante válido',
            valid: true,
        },
        {
            name: 'nameTemplate',
            message: 'Preencha um nome de template válido',
            valid: true,
        },
        {
            name: 'idOpeningMode',
            message: 'Preencha Origem do atendimento válida',
            valid: true,
        },

    ];

    const [validations, setValidations] = useState<Validation[]>(validationsDefault);

    useEffect(() => {
        if (props.show) {
            init();

            if (user) {
                initServices();
            }
        }

        setModalVisible(props.show);
    }, [props.show]);

    useEffect(() => {
        if (searchDebounce !== "") {
            searchKeyWords(searchDebounce);
        }
        else {
            setSearchResult([]);
        }
    }, [searchDebounce]);

    useEffect(() => {
        if (businessUnitList.length > 0 || businessAreaList.length > 0 || customerList.length > 0 || serviceGroupList.length > 0 ||
            serviceList.length > 0 || processList.length > 0 || classificationGroupList.length > 0 || classificationList.length > 0 ||
            requesterListFiltered.length > 0 || requesterList.length > 0 || attendantList.length > 0 || urgencyList.length > 0 || modeOpeningList.length > 0 || solicitationGroupList.length > 0) {

            let selectionDefaultTemp = selectionDefault;

            // if (businessUnitList.length === 1) {
            //     selectionDefaultTemp = { ...selectionDefaultTemp, idBusinessUnit: businessUnitList[0].value };
            // }

            if (businessAreaList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idBusinessArea: businessAreaList[0].value };
            }

            if (customerList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idCustomer: customerList[0].value };
            }

            if (serviceGroupList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idServiceGroup: serviceGroupList[0].value };
            }

            if (serviceList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idService: serviceList[0].value };
            }

            if (processList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idProcess: processList[0].value };
            }

            if (classificationGroupList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idClassificationGroup: classificationGroupList[0].value };
            }

            if (classificationList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idClassification: classificationList[0].value };
            }

            if (requesterListFiltered.length == 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idRequester: requesterListFiltered[0].value };
            }

            if (requesterList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idRequester: requesterList[0].value };
            }

            if (attendantList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idAttendant: attendantList[0].value };
            }

            if (urgencyList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idUrgency: urgencyList[0].value };
            }

            if (modeOpeningList.length === 1) {
                selectionDefaultTemp = { ...selectionDefaultTemp, idOpeningMode: modeOpeningList[0].value };
            }

            if (selectionDefaultTemp !== selectionDefault) {
                setSelectionDefault(selectionDefaultTemp);
            }
        }
    }, [businessUnitList, businessAreaList, customerList, serviceGroupList, serviceList, processList, classificationGroupList, classificationList, requesterList, requesterListFiltered, attendantList, urgencyList, modeOpeningList, solicitationGroupList]);

    useEffect(() => {
        if (!groupSelection) {
            setSelectionDefault({
                ...selectionDefault,
                // idBusinessUnit: 0,
                idCustomer: 0,
                idServiceGroup: 0,
                idService: 0,
                idProcess: 0,
                idClassification: 0,
                idClassificationGroup: 0,
                idRequester: 0,
                idAttendant: 0,
                idUrgency: 1,
                idOpeningMode: 0
            });
        }

        setCustomerList([]);
        setServiceGroupList([]);
        setServiceList([]);
        setProcessList([]);
        setClassificationGroupList([]);
        setClassificationList([]);
        setRequesterList([]);
        setAttendantList([]);
        setTemplatePPForm(undefined);

        if (props.show === true && selectionDefault.idBusinessArea > 0) {
            // getBusinessUnitList(selectionDefault.userId, selectionDefault.idBusinessArea);
            getCustomerList(selectionDefault.userId, selectionDefault.idBusinessArea);
            getOpeningMode(selectionDefault.idBusinessArea);
            getSolicitationGroups(selectionDefault.idBusinessArea);
        }
    }, [selectionDefault.idBusinessArea]);

    // useEffect(() => {
    //     if (!groupSelection) {
    //         setSelectionDefault({
    //             ...selectionDefault,
    //             idCustomer: 0,
    //             idServiceGroup: 0,
    //             idService: 0,
    //             idProcess: 0,
    //             idClassification: 0,
    //             idClassificationGroup: 0,
    //             idRequester: 0,
    //             idAttendant: 0,
    //         });
    //     }

    //     setCustomerList([]);
    //     setServiceGroupList([]);
    //     setServiceList([]);
    //     setProcessList([]);

    //     setClassificationGroupList([]);
    //     setClassificationList([]);

    //     setRequesterList([]);
    //     setAttendantList([]);

    //     setTemplatePPForm(undefined);

    //     if (props.show === true) {
    //         if (selectionDefault.idBusinessUnit !== 0) {
    //             getCustomerList(selectionDefault.userId, selectionDefault.idBusinessArea, selectionDefault.idBusinessUnit);
    //         }
    //     }
    // }, [selectionDefault.idBusinessUnit]);

    useEffect(() => {
        if (!groupSelection) {
            setSelectionDefault({
                ...selectionDefault,
                idServiceGroup: 0,
                idService: 0,
                idProcess: 0,
                idClassification: 0,
                idClassificationGroup: 0,
                idAttendant: 0,
            });
        }

        setServiceGroupList([]);
        setServiceList([]);
        setProcessList([]);
        setClassificationGroupList([]);
        setClassificationList([]);
        setAttendantList([]);
        setTemplatePPForm(undefined);

        if (props.show && selectionDefault.idCustomer !== 0) {
            getRequesterList(selectionDefault.userId, selectionDefault.idCustomer);
            //getServiceGroupList(selectionDefault.userId, selectionDefault.idBusinessArea, selectionDefault.idCustomer);
        }
    }, [selectionDefault.idCustomer]);

    useEffect(() => {
        if (props.show) {
            getServiceGroupList(selectionDefault.idRequester, selectionDefault.idBusinessArea, selectionDefault.idCustomer);
        }
    }, [selectionDefault.idRequester]);

    useEffect(() => {
        updateServiceGroup()
    }, [selectionDefault.idServiceGroup]);

    useEffect(() => {
        if (!groupSelection) {
            setSelectionDefault({
                ...selectionDefault,
                idProcess: 0,
                idClassification: 0,
                idClassificationGroup: 0,
                idAttendant: 0,
            });
        }

        setProcessList([]);
        setClassificationGroupList([]);
        setClassificationList([]);
        setAttendantList([]);
        setTemplatePPForm(undefined);

        if (props.show) {
            if (selectionDefault.idService !== 0) {
                getClassificationGroupList(selectionDefault.idBusinessArea, selectionDefault.idService);
                getProcessList(selectionDefault.idRequester, selectionDefault.idBusinessArea, selectionDefault.idCustomer, selectionDefault.idServiceGroup, selectionDefault.idService);
            }
        }
    }, [selectionDefault.idService]);

    useEffect(() => {
        if (!groupSelection) {
            setSelectionDefault({
                ...selectionDefault,
                idAttendant: 0,
            });
        }

        setTemplatePPForm(undefined);

        if (props.show) {
            if (selectionDefault.idProcess !== 0) {
                getAttendantsList(selectionDefault.idProcess);
                buildExtraForm(selectionDefault.idService, selectionDefault.idProcess);
            }
        }
    }, [selectionDefault.idProcess])

    useEffect(() => {
        if (!groupSelection) {
            setSelectionDefault({
                ...selectionDefault,
                idClassification: 0,
            });
        }

        setClassificationList([]);

        if (props.show) {
            if (selectionDefault.idClassificationGroup && selectionDefault.idClassificationGroup !== 0) {
                getClassificationList(selectionDefault.idService, selectionDefault.idClassificationGroup);
            }
        }
    }, [selectionDefault.idClassificationGroup])

    useEffect(() => {
        if (
            selectionDefault.idCustomer === 0 ||
            selectionDefault.idProcess === 0 ||
            selectionDefault.idService === 0 ||
            selectionDefault.idClassification === 0 ||
            selectionDefault.idClassificationGroup === 0 ||
            selectionDefault.idRequester === 0 ||
            selectionDefault.idServiceGroup === 0 ||
            subject === '' ||
            selectionDefault.idUrgency === 0 ||
            selectionDefault.idOpeningMode === 0 ||
            detailing === '<p><br></p>' ||
            detailing === '' ||
            (saveTemplate && nameTemplate === "")
        ) {
            setDisableButton(true);
        }
        else if (templatePPForm && templatePPForm.fields) {
            let fields = templatePPForm.fields.find((item) => {
                return resultDataResult && item.required && (resultDataResult[item.name] === "" || resultDataResult[item.name] === undefined)
            });

            setDisableButton((fields) ? true : false);
        }
        else {
            setDisableButton(false)

        }
    }, [resultDataResult, selectionDefault, templatePPForm, detailing, subject, saveTemplate, nameTemplate]);

    const updateServiceGroup = async () => {
        if (!groupSelection) {
            setSelectionDefault({
                ...selectionDefault,
                idService: 0,
                idProcess: 0,
                idClassification: 0,
                idClassificationGroup: 0,
                idAttendant: 0,
            });
        }

        setServiceList([]);
        setProcessList([]);
        setClassificationGroupList([]);
        setClassificationList([]);
        setAttendantList([]);
        setTemplatePPForm(undefined);

        if (props.show) {
            if (selectionDefault.idServiceGroup !== 0) {
                await getServiceList(selectionDefault.idRequester, selectionDefault.idBusinessArea, selectionDefault.idCustomer, selectionDefault.idServiceGroup);
            }
        }
    }

    const onChangeDetailing = (e: any) => {
        setDetailing(e);
        validateCheck("detailing", e);
    }

    const onChangeSubject = (e: any) => {
        setSubject(e.target.value);
        validateCheck("subject", e.target.value);
    }

    const buildExtraForm = async (_serviceId: number, _processId: number) => {
        setDisableButton(true)
        setIsLoading(true);
        setTemplatePPForm(undefined);

        await serviceService.getForm(_processId, false, false, _serviceId, 0).then(resp => {
            if (resp.status === 200) {
                (resp.data === '')
                    ? setDisableButton(false)
                    : setTemplatePPForm(resp.data);
                setDisableButton(true);
            }
            else {
                console.error(`Error ${resp.status}: ${resp.statusText}`, resp)
            }
        });

        setIsLoading(false);
    }

    const validateCheck = (name, value) => {
        let validationsChecks = validations;
        const valitationOnList = validations.find(x => x.name === name);

        if (valitationOnList) {
            let validationAux = {
                name: valitationOnList.name,
                message: valitationOnList.message,
                valid: ((value.length && value.length === 0) || value === 0 || value === "<p><br></p>") ? false : true
            }

            if (name === "nameTemplate") {
                validationAux = {
                    ...validationAux,
                    valid: (value.length > 0 || saveTemplate === false) ? true : false
                }
            }

            validationsChecks = validationsChecks.filter(x => x.name !== name);
            validationsChecks.push(validationAux);
        }

        setValidations(validationsChecks);
    }

    const handleFiles = (files_: any[]) => {
        setFiles([...files, ...files_]);
        setOpenAttachmentModal(false);
    }

    const removeFile = (fileName: string) => {
        const files_ = files.filter(item => item.name !== fileName);
        setFiles(files_);
    };

    const init = () => {
        setSelectionDefault({ ...selectionDefaultAux });
        setOpenNotificacao(false);
        setSeverity("info");
        setMessage("");
        setDetailing("");
        setSubject("");
        setSearchResult([])
        setTemplatePPForm(undefined);
        setFiles([]);
        setSolicitationNumber(0);
        setSearch("");
        setDisable(false);
        setLoadSave(false);
        setBusinessAreaList([]);
        setBusinessUnitList([]);
        setCustomerList([]);
        setServiceGroupList([]);
        setServiceList([]);
        setProcessList([]);
        setUrgencyList([]);
        setSolicitationGroupList([]);
        setClassificationGroupList([]);
        setClassificationList([]);
        setRequesterList([]);
        setAttendantList([]);
        setModeOpeningList([]);
        setValidations(validationsDefault);
        setGroupSelection(false);
    }

    const initServices = async () => {
        setLoading(true);

        if (props.duplicateRow) {
            getServiceDuplicate();
        }

        if (props.templateSelected) {
            getServiceTemplate();
        }

        await getBusinessAreaList(Number(user.id));
        setUrgencyList(mountDropListFromEnum(SolicitationUrgencyPortugues));
        setLoading(false);
    }

    const getServiceDuplicate = async () => {
        setSubject(props.duplicateRow.subject);
        setDetailing(props.duplicateRow.details);

        setSelectionDefault({
            ...selectionDefault,
            idBusinessArea: Number(props.duplicateRow.idBusinessArea),
            idCustomer: Number(props.duplicateRow.idCustomer),
            idServiceGroup: Number(props.duplicateRow.idServiceGroup),
            idService: Number(props.duplicateRow.idService),
            idProcess: Number(props.duplicateRow.idProcess),
            idClassification: Number(props.duplicateRow.idClassification),
            idClassificationGroup: Number(props.duplicateRow.idClassificationGroup),
            idRequester: Number(props.duplicateRow.idUserRequester),
            idAttendant: Number(props.duplicateRow.idResponsibleUser),
            idUrgency: Number(props.duplicateRow.urgency),
            idOpeningMode: Number(props.duplicateRow.idOpenMode),
            idSolicitationGroup: Number(props.duplicateRow.solicitationGroupId)
        });

        setGroupSelection(true);

        buildExtraForm(props.duplicateRow.idService, props.duplicateRow.idProcess);
    };

    const getServiceTemplate = async () => {
        setSubject(props.templateSelected.subject);
        setDetailing(props.templateSelected.detail)

        setSelectionDefault({
            ...selectionDefault,
            idBusinessArea: Number(props.templateSelected.idBusinessArea),
            // idBusinessUnit: Number(props.templateSelected.idBusinessUnit),
            idCustomer: Number(props.templateSelected.idCustomer),
            idServiceGroup: Number(props.templateSelected.idServiceGroup),
            idService: Number(props.templateSelected.idService),
            idProcess: Number(props.templateSelected.idProcess),
            idClassification: Number(props.templateSelected.idClassification),
            idClassificationGroup: Number(props.templateSelected.idGroupClassification),
            idRequester: Number(props.templateSelected.idUserSolicitation),
            idAttendant: Number(props.templateSelected.idUserAttendant),
            idOpeningMode: Number(props.templateSelected.idOrigin),
            idSolicitationGroup: Number(props.templateSelected.idSolicitationGroup),
            idUrgency: Number(props.templateSelected.urgency)
        });

        setGroupSelection(true);
        buildExtraForm(props.templateSelected.idService, props.templateSelected.idProcess);
    }

    const handleCloseNotification = () => setOpenNotificacao(false);

    const notificationValidation = (mensagem: string, type: AlertColor) => {
        setMessage(mensagem);
        setSeverity(type);
        setOpenNotificacao(true);
    };

    const handleOnchangeSearch = (e: any) => setSearch(e.target.value);

    const searchSelection = (result: ServiceGroupSearch) => {
        getServiceBusca(result);
    };

    const searchKeyWords = async (search: string) => {
        setSearchResultLoading(true);

        try {
            var customerIdToSearch = user.defaultCustomer.id;

            if (selectionDefault?.idCustomer > 0) {
                customerIdToSearch = selectionDefault?.idCustomer;
            }

            var useridd = Number(user.id);

            if (selectionDefault?.idRequester > 0) {
                useridd = selectionDefault?.idRequester;
            }

            const serviceGroupResponse = await serviceGroupService.GetServicoViewFastServiceTreeTag(useridd, search, customerIdToSearch)
            setSearchResult(serviceGroupResponse.data);
        }
        catch (error) {

        }

        setSearchResultLoading(false);
    };

    // const getBusinessUnitList = async (userId: number, businessAreaId: number) => {
    //     try {
    //         var businessResponse = await businessUnitService.getAllBusinessUnit(businessAreaId);
    //         setBusinessUnitList(mountDropList(businessResponse.data));

    //         if (businessResponse.data.length > 0) {

    //             if (businessResponse.data.length === 1) {
    //                 let businessUnitId = 1;

    //                 if (businessResponse.data[0]) businessUnitId = businessResponse.data[0].id;

    //                 await getCustomerList(userId, businessAreaId, businessUnitId);
    //             }
    //         }
    //     }
    //     catch (error) {
    //         debugger;
    //     }
    // }

    const getBusinessAreaList = async (userId: number) => {
        setLoadingBusinessArea(true);

        try {
            var businessResponse = await businessAreaService.getByUserAttendantUserId(userId);
            setBusinessAreaList(textTools.mountDropList(businessResponse.data));

            // if (businessResponse.data.length === 1) {

            //     // let businessAreaId_ = 1;

            //     if (businessResponse.data[0]) businessAreaId_ = businessResponse.data[0].id;

            //     // getCustomerList(userId, businessAreaId_);
            //     //   getBusinessUnitList(userId, businessAreaId_);
            // }
        }
        catch (error) {
            debugger;
        }

        setLoadingBusinessArea(false);
    };

    const getCustomerList = async (userId: number, businessAreaId: number, businessUnitId?: number) => {
        setLoadingCustomer(true);

        try {
            var customerResponse;
            setCustomerList([]);

            if (businessAreaId !== 0) {
                if (businessUnitId && businessUnitId !== 0) {
                    customerResponse = await customerService.GetbyUserAttendantAreaIdV2(userId, businessAreaId, businessUnitId);
                }
                else {
                    customerResponse = await customerService.GetbyUserAttendantAreaId(userId, businessAreaId);
                }
            }
            else {
                if (businessUnitId && businessUnitId !== 0) {
                    customerResponse = await customerService.getCustomerbyUnit(businessUnitId);
                }
            }

            if (customerResponse.data) {

                setCustomerList(textTools.mountDropList(customerResponse.data));

                if (customerResponse.data.length === 1) {
                    let customerId_ = 2;

                    if (customerResponse.data[0]) customerId_ = customerResponse.data[0].id;

                    getServiceGroupList(userId, businessAreaId, customerId_);
                    getRequesterList(userId, customerId_);
                }
            }
        }
        catch (error) {
            debugger;
        }

        setLoadingCustomer(false);
    };

    const getRequesterList = async (userId: number, customerId: any) => {
        setLoadingRequester(true);

        try {
            const requesterResponse = await heyHoUserService.GetRequesters(userId, customerId);
            let _list = requesterResponse.data
                .map(c => {
                    return {
                        label: `${c.nome}`,
                        value: (c.idUser) ? c.idUser : c.id,
                        nick: (c.apelido) ? c.apelido : c.email
                    }
                })
                .sort((a, b) => { return a.label > b.label ? 1 : -1 });

            setRequesterList(_list);
            setRequesterListFiltered(_list)
        }
        catch (error) {
            debugger;
        }

        setLoadingRequester(false);
    }

    const getServiceGroupList = async (requesterId: number, businessAreaId: number, customerId: number) => {
        setLoadingServiceGroup(true);

        try {
            setServiceGroupList([])
            var serviceGroupResponse = await serviceGroupService.getByUserAttendantId(requesterId, businessAreaId, customerId);
            setServiceGroupList(textTools.mountDropList(serviceGroupResponse.data));

            if (serviceGroupResponse.data.length === 1) {
                let serviceGroup_ = 0;

                if (serviceGroupResponse.data[0]) serviceGroup_ = serviceGroupResponse.data[0].id;

                await getServiceList(requesterId, businessAreaId, customerId, serviceGroup_)
            }
        }
        catch (error) {
            debugger;
        }

        setLoadingServiceGroup(false);
    }

    const getServiceList = async (requesterId: number, businessAreaId: number, customerId: number, serviceGroupId: number) => {
        setLoadingService(true);

        try {
            var serviceResponse = await serviceService.GetServiceByRequesterIdAndSolicitationGroupId(selectionDefault.idRequester ?? 0, serviceGroupId);
            setServiceListAll(serviceResponse.data);
            setServiceList(textTools.mountDropList(serviceResponse.data));

            if (serviceResponse.data.length === 1) {
                let service_ = 0;

                if (serviceResponse.data[0]) service_ = serviceResponse.data[0].id;

                getProcessList(requesterId, businessAreaId, customerId, serviceGroupId, service_);
                getClassificationGroupList(businessAreaId, service_);
            }
        }
        catch (error) {
            debugger;
        }

        setLoadingService(false);
    }

    const getClassificationGroupList = async (businessAreaId: number, serviceId: number) => {
        setLoadingClassificationGroup(true);

        try {
            var classificationGroupResponse = await classificationGroupService.getClassificationGroupByServiceAndBusinessArea(serviceId, businessAreaId);
            setClassificationGroupList(textTools.mountDropList(classificationGroupResponse.data));

            if (classificationGroupResponse.data.length === 1) {
                let classificationGroupId_ = 0;

                if (classificationGroupResponse.data[0]) classificationGroupId_ = classificationGroupResponse.data[0].id;
                await getClassificationList(serviceId, classificationGroupId_);
            }
        }
        catch (error) {
            debugger;
        }

        setLoadingClassificationGroup(false);
    }

    const getClassificationList = async (serviceId: number, classificationGroupId: number) => {
        setLoadingClassification(true);

        try {
            var classificationResponse = await classificationService.getClassificationByService(serviceId, classificationGroupId);
            setClassificationList(textTools.mountDropList(classificationResponse.data));
        }
        catch (error) {
            debugger;
        }

        setLoadingClassification(false);
    }

    const getProcessList = async (userId: number, businessAreaId: number, customerId: number, serviceGroupId: number, serviceId: number) => {
        setLoadingProcess(true);

        try {
            // var processResponse = await processService.getByUserId(userId, businessAreaId, customerId, serviceGroupId, serviceId);
            var processResponse = await processService.getProcessbyService(serviceId);

            setProcessList(textTools.mountDropList(processResponse.data));

            if (processResponse.data.length === 1) {
                let processId = 0;

                if (processResponse.data[0]) processId = processResponse.data[0].id;

                await getAttendantsList(processId);
                buildExtraForm(serviceId, processId);
            }
        }
        catch (error) {
            debugger;
        }

        setLoadingProcess(false);
    };

    const getAttendantsList = async (processId: number) => {
        setLoadingAttendant(true);

        try {
            var attendantResponse = await heyHoUserService.getAttendantsByProcess(processId);
            setAttendantList(textTools.mountDropList(attendantResponse.data));
        }
        catch (error) {
            debugger;
        }

        setLoadingAttendant(false);
    }

    const getOpeningMode = async (businessAreaId: number) => {
        try {
            var attendantResponse = await modeOpeningService.getModeOpening(businessAreaId);
            setModeOpeningList(textTools.mountDropList(attendantResponse.data));
            const telefoneValue = attendantResponse.data.find(i => i.description.toString().toUpperCase() === 'TELEFONE');
            setTelefoneValue(telefoneValue);
            setSelectionDefault({
                ...selectionDefault,
                idOpeningMode: telefoneValue.id
            });
        }
        catch (error) {
            debugger;
        }
    }

    const getSolicitationGroups = async (businessAreaId: number) => {
        try {
            var solicitationResponse = await solicitationService.getSolicitationGroupByUser(Number(user.id), businessAreaId);
            setSolicitationGroupList(mountDropGroupList(solicitationResponse.data));
        }
        catch (error) {
            debugger;
        }
    }

    const mountDropGroupList = (list: any[]) => {
        // let result = [{ label: "Selecione", value: 0 }];

        if (list.length > 0) {
            let _list = list.filter(c => (c.disabled) ? c.disabled === 0 || c.disabled === false : c)
                .map(c => { return { label: c.description, value: c.id } })
                .sort((a, b) => { return a.label > b.label ? 1 : -1 });

            return [..._list];
        }
        else {
            return [];
        }
    }

    const getServiceBusca = async (result: ServiceGroupSearch) => {
        setDisableButton(true);

        let selectionDefaultTemp = {
            ...selectionDefault,
            //   idBusinessArea: result.id_area_negocio,
            //idBusinessUnit: result.id_unidade_negocio,
            //  idCustomer: result.id_departamento,
            idServiceGroup: result.id_grupo_servico,
            idService: result.id_servico,
            idProcess: result.id_processo,
        }

        if (result.id_departamento !== selectionDefaultTemp.idCustomer) {
            selectionDefaultTemp.idCustomer = result.id_departamento;
        }

        if (result.id_usuario !== selectionDefaultTemp.idRequester) {
            selectionDefaultTemp.idRequester = result.id_usuario;
        }

        if (result.id_area_negocio !== selectionDefaultTemp.idBusinessArea) {
            selectionDefaultTemp.idBusinessArea = result.id_area_negocio;
        }

        setGroupSelection(true);

        if (search.includes("@")) {
            selectionDefaultTemp = {
                ...selectionDefaultTemp,
                idRequester: result.id_usuario
            };
        }

        setSelectionDefault(selectionDefaultTemp);
        buildExtraForm(result.id_servico, result.id_processo);
    }

    const validateCheckAll = () => {
        let validationsAux: Validation[] = [];

        validations.map(validation => {
            let valueAux;

            if (validation.name === "subject") {
                valueAux = subject;
            }
            else if (validation.name === "detailing") {
                valueAux = detailing;
            }
            else if (validation.name === "nameTemplate") {
                valueAux = nameTemplate;
            }
            else if (validation.name.includes("id")) {
                valueAux = selectionDefault[validation.name];
            }

            let validationAux = {
                name: validation.name,
                message: validation.message,
                valid: ((valueAux.length && valueAux.length === 0) || valueAux === 0 || valueAux === "<p><br></p>") ? false : true
            }

            if (validation.name === "nameTemplate") {
                validationAux = {
                    ...validationAux,
                    valid: (valueAux.length > 0 || saveTemplate === false) ? true : false
                }
            }

            validationsAux.push(validationAux);
        })

        setValidations(validationsAux);

        return (validationsAux.filter(x => x.valid === false).length > 0) ? false : true;
    }

    const mountDropListFromEnum = (data: any) => {
        let result: any[] = [];

        for (let i = 0; i < Object.keys(data).length / 2; i++) {
            result.push({ label: Object.keys(data)[i + 4], value: Object.keys(data)[i] })
        }

        return result;
    }

    const handleChange = (event: any) => {
        const { name, value } = event.target;

        setSelectionDefault({
            ...selectionDefault,
            [name]: (name === "initialDate" || name === "initialTime") ? value : Number(value)
        });

        validateCheck(name, value);
        setGroupSelection(false);
    }

    const handleFilterRequester = (e: any) => {
        let filteredList = requesterList.filter(filter => {
            return filter.label.toLowerCase().includes(e.toLowerCase()) || filter.nick.toLowerCase().includes(e.toLowerCase())
        })

        setRequesterListFiltered((filteredList.length > 0) ? filteredList : requesterList);
    }

    const SelectField = (propsSelect: any) => {
        const { label, value, options, name, required, id, placeholder, disabled } = propsSelect;

        return (
            <div className={"divOrderFieldsAttendant"}>
                <SelectDropdown
                    openTrigger='click'
                    title={label}
                    value={(value) ? options.find(x => x.value == value) : ""}
                    name={name}
                    onChange={(event) => {
                        handleChange({ target: { name: name, value: event.value, label: event.label } } as any);
                    }}
                    options={options}
                    width={"22vw"}
                    height={"40px !important"}
                    id={id}
                    required={required}
                    disabled={(options.length === 0) ? true : (disabled) ? disabled : disable}
                    placeholder={placeholder}
                />
            </div>
        )
    }

    const getNameTemplate = (event: any) => {
        setNameTemplate(event.target.value);
        validateCheck("nameTemplate", event.target.value);
    }

    const handleSubmit = () => {
        setDisableButton(true);
        var block = false;

        const canSaveLocal = validateCheckAll();

        templatePPForm &&
            templatePPForm.fields &&
            templatePPForm.fields.map((item) => {
                try {
                    if (!(resultDataResult && resultDataResult[item.name])) {
                        item.required && notificationValidation(`${item.required.required}`, "warning");
                        if (item.required) block = true;
                    }
                } catch (e) {
                    debugger;
                }
            });

        if (block) {
            return;
        }
        else if (!canSaveLocal) {
            return;
        }
        else {
            setDisable(true);
            setLoadSave(true);

            let newSolicitationTemp: FastSolicitationAttendant = {
                ...newSolicitation,
                idUserRequester: Number(selectionDefault.idRequester),
                idUserOpening: Number(user.id),
                aditionalName: String(user.name),
                nicknameUserRequester: String(user.nickName),
                subject: subject,
                // detailing: util.cleanAllTags(detailing),
                detailing: detailing,
                idService: selectionDefault.idService,
                idProcess: selectionDefault.idProcess,
                idCustomer: selectionDefault.idCustomer,
                idClassification: selectionDefault.idClassification,
                idGroupClassificationTemplate: selectionDefault.idClassificationGroup,
                modeOpening: selectionDefault.idOpeningMode,
                startDate: new Date(),
                suggestedDate: new Date(selectionDefault.initialDate + "T" + selectionDefault.initialTime),
                IdAttendant: selectionDefault.idAttendant,
                idUserAttendantTemplate: selectionDefault.idAttendant
            };

            let urgency_ = 1;
            let urgencyUser = 1;
            let urgencyService = 1;

            const service = serviceListAll.find(x => x.id === selectionDefault.idService);

            if (service && service.impact) {
                urgencyService = service.impact;
            }

            if (user.urgencyPermission === 1) {
                urgencyUser = selectionDefault.idUrgency;
            }

            urgency_ = (urgencyUser > urgencyService) ? urgencyUser : urgencyService;

            newSolicitationTemp = {
                ...newSolicitationTemp,
                urgency: urgency_,
            };

            if (selectionDefault.idCustomer === 0) {
                let customer_ = 2;

                newSolicitationTemp = {
                    ...newSolicitationTemp,
                    idCustomer: customer_,
                };
            }

            if (saveTemplate === true && nameTemplate !== "") {
                newSolicitationTemp = {
                    ...newSolicitationTemp,
                    saveTemplate: 1,
                    nameTemplate: nameTemplate
                };
            }

            notificationValidation("Aguarde um instante", "info");

            if (resultDataResult) {
                newSolicitationTemp.SolicitationFormResponseView = { idSolicitation: 0, responses: resultDataResult };
            }

            setNewSolicitation(newSolicitationTemp);
            saveSolicitation(newSolicitationTemp);
        }
    }

    const saveSolicitation = async (solicitation: any) => {

        var fastSolicitationResponse = await fastSolicitationService.newSolicitationAttendant(solicitation);
        const solicitationNumber: number = fastSolicitationResponse.data.id;

        setSolicitationNumber(solicitationNumber);
        saveSolicitationAttachment(solicitationNumber);
    };

    const saveSolicitationAttachment = async (solicitationNumber: number) => {
        for (let index = 0; index < files.length; index++) {
            try {
                await solicitationAttachmentService.sendFile(files[index], solicitationNumber, CommentType.External, Number(user.id));
            }
            catch (error) {
                debugger;
            }
        }

        finishSolicitation(solicitationNumber);
        setLoadSave(false);
    };

    const finishSolicitation = (solicitationNumber: number) => {
        setMessage(`Chamado ${solicitationNumber} criado com sucesso`);
        setSeverity("success");
        // setOpenNotificacaoCreatedTicket(true);
        setTimeout(() => {
            handleClose();
        }, 3000)
    }

    // const handleCloseAlertOK_ = (event?: React.SyntheticEvent | Event, reason?: string) => {

    //     if (reason === 'clickaway') {
    //         return;
    //     }

    //     // setOpenNotificacaoCreatedTicket(false);
    // };

    const copyToClipbord = (solicitationNumber: number) => {
        navigator.clipboard.writeText(solicitationNumber.toString());
    };

    const handleClose = () => {
        setModalVisible(false);
        setOpenNotificacao(false);
        props.handleClose();
    }

    const formatBytes = (bytes, decimals = 2) => {
        if (bytes === 0) {
            return '0 Bytes';
        }

        const k = 1024;
        const dm = (decimals < 0) ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    return (
        <SideModal
            header={"Novo chamado"}
            visible={modalVisible}
            onClose={() => handleClose()}
            width={!menu.toggle ? 'calc(100% - 260px)' : 'calc(100% - 5rem)'}
            fixedHeader={true}
        >
            <LcLoading loading={loading} label="Carregando...">
                <form style={{ width: '95%', paddingLeft: '2rem', display: "initial", flexWrap: "nowrap" }} autoComplete="off">
                    <div style={{ marginBottom: "30px" }}>
                        <div className={"divOrderFieldsAttendant"}>
                            <label className={"input-4 label2"} style={{ marginBottom: 0, marginLeft: "5px" }}> Assunto </label>
                            <div className="input-12" style={{ width: "100%" }}>
                                <PPTextField
                                    style={{ color: subject ? "black" : "#abaebd" }}
                                    required={true}
                                    placeholder={"Descreva sucintamente seu assunto ou problema"}
                                    onChange={onChangeSubject}
                                    value={subject}
                                    autoComplete={"off"}
                                    disabled={disable}
                                    help={validations.find(x => 'subject' === x.name)?.message}
                                    error={!validations.find(x => 'subject' === x.name)?.valid}
                                    id={"attendantSubject"}
                                />
                            </div>
                        </div>

                        <div className={"divOrderFieldsAttendant"} style={{ marginTop: '20px' }}>
                            {/* <HHRichTextBoxDescriptionNew
                            label={"Detalhamento"}
                            height={"150px"}
                            placeholder={"Informe aqui os detalhes"}
                            handleChange={onChangeDetailing}
                            value={detailing}
                            required={true}
                            disabled={disable}
                            help={validations.find(x => 'detailing' === x.name)?.message}
                            error={!validations.find(x => 'detailing' === x.name)?.valid}
                            handleFiles={handleFiles}
                        /> */}

                            <HHDescriptionTextBox
                                label={"Detalhamento"}
                                height={"150px"}
                                placeholder={"Informe aqui os detalhes"}
                                handleChange={onChangeDetailing}
                                value={detailing}
                                required={true}
                                disabled={disable}
                                help={validations.find(x => 'detailing' === x.name)?.message}
                                error={!validations.find(x => 'detailing' === x.name)?.valid}
                                handleFiles={handleFiles}
                                id={"attendantDetails"}
                            />
                        </div>

                        {
                            files.length > 0 &&
                            <LcAccordion title={"Anexos (" + files.length + ")"} visible={true}>
                                <div className={"divOrderAttachmentShowAttendant"}>
                                    {
                                        files && files.map(file => {
                                            let size = formatBytes(file.size);

                                            return (
                                                <div className='divShowfile'>
                                                    <LcIcon
                                                        icon={"ppi ppi-paper-clip"}
                                                        size={"small"}
                                                        color={'#898DA6'}
                                                    />
                                                    <div className="divOrderAttachmentShow">
                                                        <span className={"spanLabelAttendantAnexo"}>{file.name}</span>
                                                        <span className={"spanSize"}>{size}</span>
                                                    </div>
                                                    <LcIconLink
                                                        icon={"ppi ppi-x"}
                                                        tooltip={"Remover"}
                                                        size={"small"}
                                                        onClick={() => removeFile(file.name)}
                                                        color={"red"}
                                                        disabled={disable}
                                                    />
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </LcAccordion>
                        }
                    </div>

                    <LcAccordion title={"Negócio / serviço"} visible iconNormal>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', height: "70px" }}>
                            <LcLoading loading={loadingBusinessArea} label={"Carregando..."} width={"22vw"}>
                                <SelectField
                                    required
                                    value={(businessAreaList.length && selectionDefault.idBusinessArea > 0) ? selectionDefault.idBusinessArea : ""}
                                    options={businessAreaList}
                                    name={"idBusinessArea"}
                                    label={'Área de negócio'}
                                    id={"attendantBusinessArea"}
                                />
                            </LcLoading>

                            {/*<SelectField*/}
                            {/*    required*/}
                            {/*    label={"Unidade de negócio"}*/}
                            {/*    value={selectionDefault.idBusinessUnit}*/}
                            {/*    options={businessUnitList}*/}
                            {/*    name={"idBusinessUnit"}*/}
                            {/*/>*/}

                            <LcLoading loading={loadingCustomer} label={"Carregando..."} width={"22vw"}>
                                <SelectField
                                    required
                                    value={(customerList.length && selectionDefault.idCustomer > 0) ? selectionDefault.idCustomer : ""}
                                    options={customerList}
                                    name={"idCustomer"}
                                    label={'Cliente'}
                                    id={"attendantCustomer"}
                                />
                            </LcLoading>

                            {/* <SelectField
                                required
                                value={requesterList.length && selectionDefault.idRequester > 0 ? selectionDefault.idRequester : ""}
                                options={requesterList}
                                name={"idRequester"}
                                label={'Solicitante'}
                            /> */}

                            <LcLoading loading={loadingRequester} label={"Carregando..."} width={"22vw"}>
                                <SelectField
                                    required
                                    label={'Solicitante'}
                                    value={(requesterListFiltered.length && selectionDefault.idRequester > 0) ? selectionDefault.idRequester : ''}
                                    options={requesterListFiltered}
                                    name={'idRequester'}
                                    disabled={(requesterListFiltered.length === 0) ? true : disable}
                                    placeholder={`Selecione o Solicitante`}
                                    id={"attendantRequester"}
                                />
                            </LcLoading>
                        </div>

                        <hr />
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", margin: "10px" }}>
                            <div className={"input-4 label2"} style={{ display: "table-cell", flexDirection: "row", marginRight: "10px", marginBottom: '0px' }}>Pesquisar</div>
                            <div style={{ display: "table-cell", flexDirection: "row" }}>
                                <LcDropDown
                                    element={
                                        <div style={{ width: "55vw", maxHeight: "400px", overflowX: "hidden", cursor: (disable) ? "not-allowed !important" : "default" }}>
                                            <PPTextField
                                                placeholder={"Grupo, serviço, assunto..."}
                                                onChange={handleOnchangeSearch}
                                                value={search}
                                                disabled={disable}
                                                autoComplete={"off"}
                                            />
                                        </div>
                                    }
                                    width={"55vw"}
                                    onEnterClose={true}
                                    trigger={"keyPress"}
                                    disabled={disable}
                                >
                                    {
                                        searchResultLoading && <span className="item"> Carregando ... </span>
                                    }
                                    {
                                        ((searchResult.length === 0 && search !== "")) && !searchResultLoading && <span className="item"> Nenhum registro encontrado.</span>
                                    }
                                    {
                                        !searchResultLoading && (!(searchResult.length === 0 && search !== "")) &&
                                        <div style={{ display: "flex", flexDirection: "column" }}>
                                            {
                                                searchResult && searchResult.slice(0, 10).map(result => {
                                                    return (
                                                        <>
                                                            <span className={"spanLabelAttendant"} onClick={() => searchSelection(result)}>
                                                                {
                                                                    (() => {
                                                                        let temp = result.path;

                                                                        var result_ = '';

                                                                        if (typeof temp === 'string' && typeof search === 'string') {
                                                                            var searchMask = escapeRegExp(search);
                                                                            var regEx = new RegExp(searchMask, "ig");
                                                                            var replaceMask = `<b>${searchMask.toUpperCase()}</b>`;

                                                                            result_ = temp.replace(regEx, replaceMask);
                                                                        }

                                                                        return <>{Parse(result_)}</>;
                                                                    })()
                                                                }
                                                            </span>
                                                        </>
                                                    );
                                                })
                                            }
                                        </div>
                                    }
                                </LcDropDown>
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", height: "70px", margin: '5px 0' }}>
                            <LcLoading loading={loadingServiceGroup} label={"Carregando..."} width={"22vw"}>
                                <SelectField
                                    required
                                    value={(serviceGroupList.length && selectionDefault.idServiceGroup > 0) ? selectionDefault.idServiceGroup : ""}
                                    options={serviceGroupList}
                                    name={"idServiceGroup"}
                                    label={'Grupo de serviço'}
                                    id={"attendantServiceGroup"}
                                />
                            </LcLoading>

                            <LcLoading loading={loadingService} label={"Carregando..."} width={"22vw"}>
                                <SelectField
                                    required
                                    value={(serviceList.length > 0 || selectionDefault.idService > 0) ? selectionDefault.idService : ""}
                                    name={'idService'}
                                    options={serviceList}
                                    label={'Serviço'}
                                    id={"attendantService"}
                                />
                            </LcLoading>

                            <LcLoading loading={loadingProcess} label={"Carregando..."} width={"22vw"}>
                                <SelectField
                                    required
                                    value={(processList.length > 0 || selectionDefault.idProcess > 0) ? selectionDefault.idProcess : ""}
                                    name={'idProcess'}
                                    options={processList}
                                    label={'Processo'}
                                    id={"attendantProcess"}
                                />
                            </LcLoading>
                        </div>

                        <div style={{ display: "flex", flexDirection: "row", height: "70px", margin: '5px 0' }}>
                            <LcLoading loading={loadingClassificationGroup} label={"Carregando..."} width={"22vw"}>
                                <SelectField
                                    required
                                    value={(classificationGroupList.length && selectionDefault.idClassificationGroup > 0) ? selectionDefault.idClassificationGroup : ""}
                                    options={classificationGroupList}
                                    name={"idClassificationGroup"}
                                    label={'Grupo de classificação'}
                                    id={"attendantClassificationGroup"}
                                />
                            </LcLoading>

                            <LcLoading loading={loadingClassification} label={"Carregando..."} width={"22vw"}>
                                <SelectField
                                    required
                                    value={(classificationList.length && selectionDefault.idClassification > 0) ? selectionDefault.idClassification : ""}
                                    name={'idClassification'}
                                    options={classificationList}
                                    label={'Classificação'}
                                    id={"attendantClassification"}
                                />
                            </LcLoading>

                            <SelectField
                                required
                                value={(urgencyList.length && selectionDefault.idUrgency > 0) ? selectionDefault.idUrgency : ""}
                                options={urgencyList}
                                name={"idUrgency"}
                                label={'Urgência'}
                                id={"attendantUrgency"}
                            />
                        </div>

                        <div style={{ display: "flex", flexDirection: "row", height: "70px", margin: '5px 0' }}>
                            <SelectField
                                required
                                value={(modeOpeningList.length && selectionDefault.idOpeningMode > 0) ? selectionDefault.idOpeningMode : telefoneValue && telefoneValue.id}
                                options={modeOpeningList}
                                name={"idOpeningMode"}
                                label={'Origem do atendimento'}
                                id={"attendantOpeningMode"}
                            />

                            <LcLoading loading={loadingAttendant} label={"Carregando..."} width={"22vw"}>
                                <SelectField
                                    value={(attendantList.length && selectionDefault.idAttendant > 0) ? selectionDefault.idAttendant : ""}
                                    options={attendantList}
                                    name={"idAttendant"}
                                    label={'Atendente'}
                                    id={"attendantAttendant"}
                                />
                            </LcLoading>
                            <div className={"divOrderFieldsAttendant"} style={{ marginLeft: '0' }}>
                                <div className={"input-4 label2"} style={{ paddingLeft: "10px", marginBottom: '0px' }}> Data de abertura </div>
                                <PPTextField
                                    type={"date"}
                                    name={'initialDate'}
                                    onChange={handleChange}
                                    style={{ width: "10vw", marginTop: '3px' }}
                                    value={selectionDefault.initialDate}
                                    disabled={true}
                                />
                            </div>

                            <div className={"divOrderFieldsAttendant"} style={{ paddingLeft: "5px" }}>
                                <div className={"input-4 label2"} style={{ paddingLeft: "10px", marginBottom: '0px' }}> Hora de abertura </div>
                                <PPTextField
                                    type={"time"}
                                    name={'initialTime'}
                                    onChange={handleChange}
                                    style={{ width: "10vw", marginTop: '3px' }}
                                    value={selectionDefault.initialTime}
                                    disabled={!user.allowChangeTime}
                                />
                            </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "row", height: "70px", margin: '5px 0' }}>
                            <div style={{ display: "flex", alignItems: "center", marginLeft: "20px", width: "21.5vw", height: "50px" }}>
                                <input
                                    type={"checkbox"}
                                    onChange={(e) => setSaveTemplate(e.target.checked)}
                                    disabled={disable}
                                    style={{ transform: "scale(1.5)" }}
                                />
                                <div className={"input-4 label2"} children={"Salvar template"} style={{ marginLeft: "20px", marginBottom: "0px" }} />
                            </div>

                            <div hidden={!saveTemplate} >
                                <div className={"input-4 label2"} children={"Nome do template"} style={{ paddingLeft: "5px", marginBottom: "0" }} />
                                <PPTextField
                                    required={saveTemplate}
                                    placeholder={"Nome do template"}
                                    onChange={getNameTemplate}
                                    value={nameTemplate}
                                    disabled={disable}
                                    style={{ width: "22vw", overflow: 'auto' }}
                                    autoComplete={"off"}
                                    help={validations.find(x => 'nameTemplate' === x.name)?.message}
                                    error={!validations.find(x => 'nameTemplate' === x.name)?.valid}
                                />
                            </div>
                        </div>
                    </LcAccordion>

                    {
                        isloading &&
                        <CircularProgress />
                    }

                    {
                        !isloading && templatePPForm &&
                        <LcAccordion title={(templatePPForm && templatePPForm.title) ? templatePPForm.title : ''} visible={true}>
                            <PPFormHH
                                header={''}
                                EditForm={!disable}
                                data={resultData}
                                template={templatePPForm}
                                detailButton={false}
                                visible={!disable}
                                enableNotifications={true}
                                refreshSeed={refreshSeed}
                                setResultData={(data: any) => setResultDataResult(data)}
                                setError={(error: any) => { setError(error); }}
                                disableFields={disable}
                                maxWidth={"33vw"}
                                maxWidthInternal={"32vw"}
                            />
                        </LcAccordion>
                    }

                    <div hidden={!disable} style={{ marginLeft: "1vw", display: (disable) ? "flex" : "none" }} className={"divOrderLoadingAttendant"}>
                        {
                            loadSave &&
                            <PPGrid container justifyContent={"center"} alignItems={"center"} className={"loadingCreateAttendant"}>
                                <CircularProgress />
                            </PPGrid>
                        }
                    </div>

                    <div className={"divOrderTextBoxAttendant"} style={{ padding: "10px 0px" }}>
                        <button
                            type={"button"}
                            className={"lc-button bg-info"}
                            disabled={disableButton}
                            onClick={() => handleSubmit()}
                            style={{ marginRight: "20px" }}> Abrir chamado </button>

                        <button
                            type={"button"}
                            className={"lc-button bg-info"}
                            onClick={() => setOpenAttachmentModal(true)}
                            disabled={disable}> Anexar arquivo </button>
                    </div>

                    {
                        menu.showHelper &&
                        <div style={{ paddingBottom: "1000px" }} />
                    }

                    <Modal title={"Anexar arquivo"} visible={openAttachmentModal} close={() => setOpenAttachmentModal(false)}>
                        <PPUploader
                            onDropFile={(files: any[]) => handleFiles(files)}
                            promptMessage={"Solte o arquivo aqui (máx. 10MB)"}
                            maxSize={10240}
                            largeFile={"Este componente não suporta arquivos maiores que 10Mb."}
                        />
                    </Modal>

                    <Snackbar open={openNotificacao} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                        onClose={handleCloseNotification}>
                        <Alert variant="filled" severity={severity} onClose={handleCloseNotification} style={{ height: "48px" }}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <span className={(severity !== "success") ? "spanLabelNoSucess" : "spanLabelSucess"}>{message}</span>
                                {
                                    severity === "success" &&
                                    <div style={{ marginTop: "-3px" }}>
                                        <LcIconLink
                                            icon={"ppi ppi-duplicate"}
                                            size={'small'}
                                            tooltip={'Copiar número de chamado'}
                                            tooltipColor={"grey"}
                                            onClick={() => copyToClipbord(solicitationNumber)}
                                        />
                                    </div>
                                }
                            </div>
                        </Alert>
                    </Snackbar>
                </form>
            </LcLoading>
        </SideModal>
    );
};

export default AttendanceNewSolicitation;